import React from "react";
import { List } from "../../Menu/List";
import { useSelector } from "react-redux";
import Skeleton from "@material-ui/lab/Skeleton";
import MList from "@material-ui/core/List";
import LoadingCell from "../../Menu/LoadingCell";

const FilterResult = () => {
  //REDUX
  const cart = useSelector((state) => state.cart.cart);
  const [isMobile, setIsMobile] = React.useState(undefined);
  const language = useSelector((state) => state.store.language);
  const settings = useSelector((state) => state.store.store.settings);
  const loading = useSelector((state) => state.productFilter.loading);
  const isNotificationDismissed = useSelector(
    (state) => state.store.isNotificationDismissed
  );
  const filters = useSelector((state) => state.productFilter);
  const layout = useSelector(
    (state) => state.store.store.settings?.store_layout
  );
  const checkLayout =
    filters.filtersSelected.length > 0 ||
    layout === "grid" ||
    layout === "grid2" ||
    layout === "scroll";

  const categories = useSelector((state) =>
    checkLayout
      ? state.productFilter.fetchedCategories
      : state.store.store.categories
  );

  const nutritionalFactMaxMin = useSelector(
    (state) => state.productFilter?.allProductNutritionFact
  );

  const categoryList = categories
    .filter((category) =>
      filters.selectedCategories.length === 0
        ? true
        : filters.selectedCategories.includes(category.id)
    )
    .map((category) => {
      return (
        <List
          key={category.id}
          category={category}
          isMobile={isMobile}
          filter={false}
          settings={settings}
          language={language}
          isNotificationDismissed={isNotificationDismissed}
          filters={filters}
          sortOption={filters.sortBy.value}
          cart={cart}
          nutritionalFactMaxMin={nutritionalFactMaxMin}
        />
      );
    });
  const loadingSpinner = (
    <div className="pt-3">
      <Skeleton variant="rect" style={{ height: 35 }} />
      <MList
        component="nav"
        aria-label="main mailbox folders"
        style={{
          width: "100%",
          backgroundColor: "white",
          paddingBottom: 8,
          paddingTop: 8,
        }}
      >
        <LoadingCell />
        <LoadingCell />
        <LoadingCell />
        <LoadingCell />
        <LoadingCell />
      </MList>
    </div>
  );

  const noResult = (
    <p>
      {language !== "arabic" ? "No Result Found" : "لم يتم العثور على اي منتج"}
    </p>
  );
  return (
    <div className="mb-5 w-100 ">
      {loading
        ? loadingSpinner
        : categoryList.length > 0
        ? categoryList
        : noResult}
    </div>
  );
};

export default FilterResult;
